"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const prop_types_1 = __importDefault(require("prop-types"));
const Typography = ({ children, ...restProps }) => (react_1.default.createElement(Typography_1.default, { ...restProps }, children));
Typography.defaultProps = {
    align: 'inherit',
    classes: {},
    color: 'initial',
    component: undefined,
    gutterBottom: false,
    noWrap: false,
    paragraph: false,
    variant: 'body1',
    variantMapping: {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
        subtitle1: 'h6',
        subtitle2: 'h6',
        body1: 'div',
        body2: 'p',
    },
};
Typography.propTypes = {
    align: prop_types_1.default.oneOf(['left', 'inherit', 'center', 'right', 'justify']),
    classes: prop_types_1.default.objectOf(prop_types_1.default.any),
    color: prop_types_1.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
    component: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string]),
    gutterBottom: prop_types_1.default.bool,
    noWrap: prop_types_1.default.bool,
    paragraph: prop_types_1.default.bool,
    variant: prop_types_1.default.oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'overline',
        'inherit',
    ]),
    variantMapping: prop_types_1.default.objectOf(prop_types_1.default.string),
};
exports.default = Typography;
//# sourceMappingURL=typography.js.map